import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../icon.interface';

const SomethingWentWrong = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        width="174"
        height="192"
        viewBox="0 0 174 192"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <g clipPath="url(#clip0_686_18797)">
          <path
            d="M165.966 40.2553C176.319 52.4914 175.143 74.3765 170.907 91.9335C166.623 109.535 159.233 122.861 148.88 138.771C138.527 154.681 125.218 173.213 107.605 177.497C89.9922 181.781 68.163 171.77 48.9619 155.86C29.7608 139.949 13.1437 118.053 8.72127 91.7921C4.30182 65.4816 12.0152 34.7487 31.2193 22.5127C50.4233 10.2767 81.1533 16.5346 107.464 20.96C133.724 25.4295 155.609 28.0193 165.966 40.2553Z"
            fill="#F2F7FF"
          />
          <path
            d="M83.8337 59.4238C83.433 61.3831 83.8691 75.4105 83.2886 77.6232C82.7082 79.8358 76.2676 106.877 76.2676 106.877L86.5119 104.046C86.5119 104.046 90.1034 96.1525 91.4057 89.046C92.5518 82.791 92.3868 59.5328 83.8337 59.4238Z"
            fill="#DB9D76"
          />
          <path
            d="M73.8905 65.6176H67.2436L63.437 51.1807H70.0868L73.8905 65.6176Z"
            fill="#1A1A1A"
          />
          <path
            d="M159.97 105.761H87.7529V177.978H159.97V105.761Z"
            fill="#D2D2D2"
          />
          <path
            d="M101.126 127.448C105.145 127.448 108.404 124.19 108.404 120.171C108.404 116.152 105.145 112.894 101.126 112.894C97.1071 112.894 93.8489 116.152 93.8489 120.171C93.8489 124.19 97.1071 127.448 101.126 127.448Z"
            fill="#818180"
          />
          <path
            d="M114.52 117.051H151.416"
            stroke="white"
            strokeWidth="0.567407"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M114.52 123.288H130.878"
            stroke="white"
            strokeWidth="0.567407"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M114.52 138.751H151.416"
            stroke="white"
            strokeWidth="0.567407"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M114.52 144.988H130.878"
            stroke="white"
            strokeWidth="0.567407"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M114.52 160.447H151.416"
            stroke="white"
            strokeWidth="0.567407"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M114.52 166.685H130.878"
            stroke="white"
            strokeWidth="0.567407"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M101.126 149.146C105.145 149.146 108.404 145.887 108.404 141.868C108.404 137.849 105.145 134.591 101.126 134.591C97.1071 134.591 93.8489 137.849 93.8489 141.868C93.8489 145.887 97.1071 149.146 101.126 149.146Z"
            fill="white"
          />
          <path
            d="M101.126 170.845C105.145 170.845 108.404 167.587 108.404 163.567C108.404 159.548 105.145 156.29 101.126 156.29C97.1071 156.29 93.8489 159.548 93.8489 163.567C93.8489 167.587 97.1071 170.845 101.126 170.845Z"
            fill="white"
          />
          <path
            d="M18.8059 173.703L25.5971 169.793L29.8929 177.66L21.982 181.566L18.8059 173.703Z"
            fill="#FFB688"
          />
          <path
            d="M68.6311 169.793L70.1455 178.487L79.3291 176.926L76.3003 167.059L68.6311 169.793Z"
            fill="#FFB688"
          />
          <path
            d="M91.3587 100.543C88.654 100.69 44.2738 110.328 43.6963 112.587C38.9439 131.126 66.0882 170.04 68.0829 171.219C70.2337 170.7 77.5729 168.143 77.5729 168.143L75.8876 142.195L91.3587 100.543Z"
            fill="#0057CB"
          />
          <path
            d="M23.9829 182.786L18.5617 171.455L3.80957 157.339L0 159.437L14.6048 187.427L23.9829 182.786Z"
            fill="#1A1A1A"
          />
          <path
            d="M80.0247 174.843L67.6561 177.047L50.1138 187.497L51.1244 191.731L81.9957 185.119L80.0247 174.843Z"
            fill="#1A1A1A"
          />
          <path
            d="M125.595 89.0469C127.321 90.4287 129.13 96.6572 129.34 98.7697C131.599 123.277 91.2616 137.708 85.6754 140.13C80.372 144.564 34.115 178.665 31.2954 179.472C28.4758 180.279 23.8648 169.454 24.2685 168.008C24.6721 166.561 92.4696 98.4073 92.4696 98.4073L125.595 89.0469Z"
            fill="#006DFF"
          />
          <path
            d="M93.1598 44.9313C87.4528 42.1117 82.1759 57.5769 82.6827 59.3476C83.1895 61.1183 88.428 61.6251 89.7538 61.6251C91.0797 61.6251 93.1598 44.9313 93.1598 44.9313Z"
            fill="#00355B"
          />
          <path
            d="M104.102 36.0596C124.932 36.0596 126.897 85.7196 126.662 89.1078C124.558 96.0139 99.3259 104.311 91.5594 99.7705C79.235 70.8731 84.9125 36.0596 104.102 36.0596Z"
            fill="#00355B"
          />
          <path
            d="M124.882 60.5439C126.046 62.5298 128.55 75.4699 128.3 77.1582C128.049 78.8464 124.175 83.1068 122.796 83.201C103.191 84.5328 81.9279 76.6985 77.9533 74.4977C69.6388 73.8347 64.7185 70.8324 64.7185 66.4424C64.7185 63.8497 66.1563 61.9817 66.9489 61.9817C68.4515 61.9817 71.1208 64.5715 71.4449 65.3287C70.7967 63.997 68.7638 61.5516 70.4373 61.5516C70.9028 61.5516 74.68 66.8314 76.7306 68.113C78.7812 69.3946 108.377 70.47 114.311 72.6267C113.554 71.1182 111.432 65.6499 111.397 64.8603C111.361 64.0707 124.882 60.5439 124.882 60.5439Z"
            fill="#FFB688"
          />
          <path
            d="M110.092 40.0166C119.11 36.7108 126.24 57.5471 125.949 60.187C125.657 62.8269 111.217 67.4496 109.591 66.495C107.964 65.5404 101.152 43.2929 110.092 40.0166Z"
            fill="#00355B"
          />
          <path
            d="M104.691 27.0234C104.594 28.2756 105.357 35.2731 106.551 37.5565C106.023 38.5936 100.602 41.6077 98.0063 40.9624C97.6527 39.0237 96.7128 33.8176 95.9438 32.2325C97.3316 31.5077 104.691 27.0234 104.691 27.0234Z"
            fill="#DB9D76"
          />
          <path
            d="M98.0292 33.0978C104.342 31.4227 107.758 23.6503 105.659 15.7377C103.559 7.82504 96.7394 2.76849 90.4263 4.44357C84.1132 6.11864 80.6973 13.891 82.7968 21.8037C84.8963 29.7163 91.7161 34.7729 98.0292 33.0978Z"
            fill="#FFB688"
          />
          <path
            d="M99.7829 18.5765C99.1288 18.6118 96.6333 17.339 96.0794 13.5206C94.2792 13.226 86.3419 14.0716 82.1817 17.3508C80.6408 17.9401 79.3915 18.4321 77.061 18.4321C75.9561 18.4321 75.0192 17.2771 75.0192 16.4846C75.0192 14.3014 75.9561 12.1859 78.6933 12.0445C76.3892 11.9944 74.2532 10.5713 74.2532 9.52246C74.2532 8.12886 77.4204 3.85377 82.9448 5.72762C81.6484 4.79069 80.1841 3.87734 80.1841 2.9905C80.1841 1.47315 82.3673 0 86.1857 0C92.0931 0 98.5307 2.44838 99.9214 4.20143C100.57 3.86555 101.395 3.24094 102.974 3.24094C106.91 3.24094 108.23 15.9925 106.527 20.2676C106.105 20.5386 105.633 20.7219 105.139 20.8068"
            fill="#1A1A1A"
          />
          <path
            d="M99.6646 18.8562C99.8599 18.3002 100.22 17.8167 100.696 17.4697C101.172 17.1227 101.743 16.9286 102.332 16.9131C102.921 16.8976 103.501 17.0615 103.995 17.383C104.489 17.7045 104.873 18.1685 105.097 18.7134C105.322 19.2584 105.375 19.8587 105.25 20.4346C105.126 21.0106 104.829 21.5352 104.4 21.9389C103.971 22.3425 103.429 22.6062 102.846 22.6949C102.264 22.7837 101.668 22.6934 101.138 22.4359"
            fill="#FFB688"
          />
        </g>
        <rect
          x="52.5"
          y="34.6699"
          width="18"
          height="16"
          rx="2"
          transform="rotate(-18.3607 52.5 34.6699)"
          fill="#FFE8EB"
        />
        <path
          d="M67.0269 49.8673L64.438 47.5656L67.7257 46.4744L67.0269 49.8673Z"
          fill="#FFE8EB"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M58.754 36.8647C58.9239 36.526 59.3362 36.3892 59.6749 36.5591L63.6869 38.5716L65.6995 34.5596C65.8694 34.2209 66.2816 34.084 66.6203 34.2539C66.959 34.4238 67.0958 34.8361 66.926 35.1748L64.9134 39.1869L68.9255 41.1994C69.2642 41.3693 69.401 41.7816 69.2311 42.1202C69.0612 42.4589 68.649 42.5958 68.3103 42.4259L64.2982 40.4133L62.2856 44.4254C62.1158 44.7641 61.7035 44.9009 61.3648 44.731C61.0261 44.5611 60.8893 44.1489 61.0592 43.8102L63.0717 39.7981L59.0596 37.7856C58.721 37.6157 58.5841 37.2034 58.754 36.8647Z"
          fill="#D20000"
        />
        <defs>
          <clipPath id="clip0_686_18797">
            <rect width="174" height="191.731" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  }
);
export default SomethingWentWrong;
